module.exports = __webpack_public_path__ + "img/Clamp.9e2f6db0.jpg";